import type { PropsWithChildren } from "react";

import { Box } from "@/ui/layout";
import { BaseCardToken } from "@/ui/layout/BaseCard";
import { ShadowStyles } from "@/ui/theme/styles";
import { ColorToken } from "@/ui/theme/tokens";

type OnboardingCardBorderRadius = "default" | "large";

const OnboardingCardBorderRadiusRecord: Record<
  OnboardingCardBorderRadius,
  number
> = {
  default: BaseCardToken.secondaryBorderRadius,
  large: BaseCardToken.primaryBorderRadius,
};

const OnboardingCardPadding = 12;

interface BaseOnboardingCardProps extends PropsWithChildren<ViewWithTestID> {
  backgroundColor?: ColorToken;
  borderColor?: ColorToken;
  borderRadius?: OnboardingCardBorderRadius;
  hasShadow?: boolean;
  isBorderDashed?: boolean;
}

const BaseOnboardingCard = ({
  backgroundColor = ColorToken.NeutralBackgroundPrimary,
  borderColor = ColorToken.NeutralLine,
  borderRadius = "default",
  children,
  hasShadow,
  isBorderDashed,
  testID,
}: BaseOnboardingCardProps) => (
  <Box
    backgroundColor={backgroundColor}
    borderColor={borderColor}
    borderRadius={OnboardingCardBorderRadiusRecord[borderRadius]}
    borderStyle={isBorderDashed ? "dashed" : "solid"}
    borderWidth={1}
    padding={OnboardingCardPadding}
    testID={testID}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...(hasShadow && ShadowStyles)}
  >
    {children}
  </Box>
);

export { BaseOnboardingCard };
export type { BaseOnboardingCardProps };
